import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Tappable from 'common/Tappable';

import APIDocsSections from './APIDocsSections';

import 'css/components/developers/docs/api/_APIDocsSectionLink.scss';

export default class APIDocsSectionLink extends Component {
  static propTypes = {
    onScrollToSection: PropTypes.func,
    sectionID: PropTypes.string.isRequired,
  };

  onTap = () => {
    const { onScrollToSection, sectionID } = this.props;
    onScrollToSection(sectionID);
  };

  render() {
    const { sectionID } = this.props;
    const section = APIDocsSections.find((section) => {
      return section.id === sectionID;
    });
    return (
      <Tappable onTap={this.onTap}>
        <div className="apiDocsSectionLink">{section.name}</div>
      </Tappable>
    );
  }
}
